/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebneedcategory3Inputs */

const en_placewebneedcategory3 = /** @type {(inputs: Placewebneedcategory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a category and at least one sub-category.`)
};

const de_placewebneedcategory3 = /** @type {(inputs: Placewebneedcategory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl eine Kategorie und mindestens eine Unterkategorie.`)
};

/**
* | output |
* | --- |
* | "Pick a category and at least one sub-category." |
*
* @param {Placewebneedcategory3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebneedcategory3 = /** @type {((inputs?: Placewebneedcategory3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebneedcategory3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebneedcategory3(inputs)
	return de_placewebneedcategory3(inputs)
});
export { placewebneedcategory3 as "placeWebNeedCategory" }